export default interface ICredential {
    id?: number
    name: string
    scope?: string
    allowed: boolean
    hasScopes?: boolean
}


export const VACATION_RESTRICT_ABSENCE_SPLIT = 'vacation_restrict_absence_split_'